import { Outlet, Link, createRootRoute, HeadContent } from "@tanstack/react-router";

import { SiteHeader } from "../components/SiteHeader";
import { SiteFooter } from "../components/SiteFooter";
import { WhatsAppFloat } from "../components/WhatsAppFloat";

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center bg-stone-100 px-4 py-32">
        <div className="max-w-md text-center">
          <h1 className="font-serif text-7xl text-navy-900">404</h1>
          <div className="mx-auto mt-6 h-px w-16 bg-gold-500"></div>
          <h2 className="mt-6 font-serif text-2xl text-navy-900">Página no encontrada</h2>
          <p className="mt-3 text-sm text-navy-900/60">
            La página que buscas no existe o ha sido movida.
          </p>
          <div className="mt-8">
            <Link
              to="/"
              className="inline-block border border-gold-500 bg-navy-900 px-8 py-4 text-[11px] font-semibold tracking-[0.2em] uppercase text-stone-100 transition-colors hover:bg-gold-500"
            >
              Volver al inicio
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { title: "Estudio Libertad E.A.E.S. — Consultores y Abogados | Asunción" },
      { name: "description", content: "Estudio Libertad E.A.E.S. en Asunción, Paraguay. Práctica civil, familia, niñez y adolescencia, comercial, societaria, penal patrimonial e inversiones en valores." },
      { name: "author", content: "Estudio Libertad E.A.E.S." },
      { property: "og:title", content: "Estudio Libertad E.A.E.S. — Consultores y Abogados" },
      { property: "og:description", content: "Práctica civil, familia, comercial, societaria y penal patrimonial en Asunción, Paraguay." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  return (
    <>
      <HeadContent />
      <div className="flex min-h-screen flex-col bg-stone-100">
        <SiteHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <SiteFooter />
        <WhatsAppFloat />
      </div>
    </>
  );
}
